<template>
  <div class="success">
    <anav name="领取成功" @back="back">
      <a @click="toUserCenter">
        <img src="https://img2.233.com/wx/union/wap/leadaclass/my-icon.png" class="nav-right">
      </a>
    </anav>
    <div class="pd10">
      <div class="content">
        <img src="https://img2.233.com/wx/union/wap/leadaclass/success-icon.png">
        <h2>领取成功！</h2>
        <div class="info">
          <div class="ps">请记住您的账户信息和学习地址</div>
          <p class="account">学习账号：{{leadInfo.currentUserName}}</p>
          <p class="account" v-if="leadInfo.haveAccount === 0">初始密码：{{leadInfo.password}}</p>
          <div class="address" v-if="leadInfo.dozDomain">
            电脑学习：<a :href="'http://' + leadInfo.dozDomain">{{leadInfo.dozDomain}}</a>
          </div>
          <div class="address" v-else>
            电脑学习：<a href="https://v.233.com/">233网校</a>
          </div>
          <div class="phone" v-if="leadInfo.dozDomain">
            手机学习 >>
            <label @click="toAppStudy">下载app学习</label>
          </div>
        </div>
      </div>
      <div class="qrcode" v-if="promoteLeadInfo.PromoteLead === 1 && (promoteLeadInfo.PromoteQrCode && promoteLeadInfo.PromoteDescription && promoteLeadInfo.PromoteTitle)">
        <div class="left">
          <span>{{promoteLeadInfo.PromoteTitle}}</span>
          <p>{{promoteLeadInfo.PromoteDescription}}</p>
        </div>
        <div class="right" @click="downloadQrcode(promoteLeadInfo.PromoteQrCode)" v-if="promoteLeadInfo.PromoteQrCode">
          <img :src="promoteLeadInfo.PromoteQrCode">
          <p>点击下载二维码</p>
        </div>
      </div>
      <RedPack v-show="this.permissionObj.UActivityFlag == 1"></RedPack>
      <div class="more" v-if="moreCourse.length > 0">
        <div class="title">更多好课免费学</div>
        <div class="box" v-for="item in moreCourse" :key="item.MyClassID" @click="is233 ? toFreeHear(item.ClassEname): toFreeStudy(item.ClassEname)">
          <div class="left" v-if="item.PicPath && !is233">
            <img :src="item.PicPath">
          </div>
          <div class="right">
            <div class="name">{{item.MyClassName}}</div>
            <div class="bottom" v-if="is233">
              <div class="price">¥{{item.GoodPrice}}</div>
              <label>免费试听</label>
            </div>
            <div class="bottom" v-else>
              <div class="time">
                <img src="https://img2.233.com/wx/union/wap/leadaclass/people-icon.png">
                <span>{{item.Teacher}}</span>
                <img src="https://img2.233.com/wx/union/wap/leadaclass/time-icon.png">
                <span>{{item.AllHour}}h</span>
              </div>
              <label>免费学习</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dialog" v-show="tips">
      <div class="tips">{{tips}}</div>
    </div>
  </div>
</template>

<script>
import RedPack from './components/RedPack.vue';
import anav from "../../components/nav/index"
import { GetLoginStatus, GetPromoteLeadInfo, GetMoreCourse, GetSeniorFlagByPromote, GetUnionPermission } from "../../lib/request"
export default {
  name: "Success",
  components: {
    anav,
    RedPack
  },
  data() {
    return {
      formList: false,
      is233: false,
      leadInfo: {},
      promoteLeadInfo: {},
      moreCourse: [],
      tips: "",
      permissionObj: {}
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => vm.formList = from.path && from.path !== "/")
  },
  created() {
    this.is233 =  location.host === 'v.233.com'
    if (this.$route.query.promoteCode) {
      this.promoteCode = this.$route.query.promoteCode
    } else {
      location.href = this.is233 ? "https://v.233.com/" : location.origin
    }
    this.leadInfo = JSON.parse(localStorage.getItem("leadInfo"))
    !this.leadInfo && this.$router.push({ path: '/', query: { promoteCode: this.promoteCode }})
    this.GetPromoteLeadInfo()
    this.GetMoreCourse()
    this.GetUnionPermission()
  },
  mounted() {
    this.GetLoginStatus()
  },
  methods: {
    GetUnionPermission() {
      GetUnionPermission({}, res => {
        const { Result } = res
        this.permissionObj = Result
      })
    },
    GetLoginStatus() {
      if (window.location.href.indexOf("v.233.com") > -1) {
        document.title = "领取成功"
      } else {
        GetLoginStatus({}, (res) => {
          const { Result } = res
          document.title = Result.webName ? "领取成功-" + Result.webName : "领取成功"
        })
      }
    },
    back() {
      this.formList ? this.$router.go(-1) : this.$router.push({ path: '/', query: { promoteCode: this.promoteCode }})
    },
    GetPromoteLeadInfo() {
      GetPromoteLeadInfo({}, (res) => {
        this.promoteLeadInfo = res.Result
      })
    },
    GetMoreCourse() {
      GetMoreCourse({ myclassid: this.leadInfo.myclassid, promoteCode: this.promoteCode }, (res) => {
        !res.ResultDescription && (this.moreCourse = res.Result)
      })
    },
    toUserCenter() {
      location.href = this.is233 ? "https://v.233.com/account/home/index" : location.origin + "/m/uc"
    },
    toFreeHear(ClassEname) {
      location.href = `https://v.233.com/${ClassEname}/`
    },
    toFreeStudy(ClassEname) {
      GetSeniorFlagByPromote({ host: location.host, promoteCode: this.promoteCode }, (res) => {
        location.href = `${location.origin}/m/${res.Result ? "fine" : "norm"}/new/#/freelessons?classename=${ClassEname}`
      })
    },
    toAppStudy() {
      location.href = this.is233 ? "https://www.233.com/shouji233/" : location.origin + "/search/app"
    },
    downloadQrcode(url) {
      let a = document.createElement("a")
      a.download = url
      a.href = url
      a.click()
      this.tips = "二维码保存成功！"
      setTimeout(() => {
        this.tips = ""
      }, 3000)
    }
  }
}
</script>

<style lang="scss" scoped>
.success{
  padding-bottom: 10px;
  .nav-right{
    height: 18px;
    cursor: pointer;
    vertical-align: text-top;
  }
  .pd10{
    padding: 10px;
  }
  .content{
    padding: 10px 20px 37px 17px;
    background: #fff;
    border-radius: 5px;
    img{
      width: 78px;
      height: 78px;
      margin: 0 auto;
      display: block;
    }
    h2{
      color: #E13B29;
      font-size: 17px;
      font-weight: 800;
      text-align: center;
      margin: 6px 0 17px;
      line-height: 17px;
    }
    .info{
      background: #FDF6EF;
      padding: 17px 0 27px 19px;
      border-radius: 5px;
      .ps{
        color: #A66D54;
        font-size: 13px;
        font-weight: 400;
        line-height: 13px;
      }
      .account{
        color: #333;
        font-size: 13px;
        font-weight: 400;
        line-height: 13px;
        margin-top: 11px;
      }
      .address{
        color: #666;
        font-size: 13px;
        font-weight: 400;
        line-height: 13px;
        margin-top: 11px;
        a{
          color: #5B81ED;
        }
      }
      .phone{
        color: #666;
        font-size: 13px;
        font-weight: 400;
        line-height: 13px;
        label{
          display: inline-block;
          width: 102px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          background: linear-gradient(45deg, #FB5D37 0%, #E13A34 99%);
          border-radius: 15px;
          font-size: 14px;
          color: #fff;
          font-weight: bold;
          margin-left: 24%;
          cursor: pointer;
        }
      }
    }
  }
  .qrcode{
    padding: 10px 11px 10px 19px;
    background: #fff;
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    .left{
      width: calc(100% - 100px);
      span{
        color: #333;
        font-size: 15px;
        font-weight: 800;
        line-height: 15px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: inline-block;
        width: 100%;

      }
      p{
        margin-top: 9px;
        color: #999;
        font-size: 13px;
        font-weight: 400;
        line-height: 17px;
        display: -webkit-box;
        overflow: hidden;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
    .right{
      min-width: 84px;
      text-align: center;
      cursor: pointer;
      img{
        width: 60px;
        height: 60px;
      }
      p{
        color: #999;
        font-size: 12px;
        font-weight: 400;
        line-height: 12px;
      }
    }
  }
  .more{
    .title{
      font-size: 14px;
      color: #333;
      font-weight: 800;
      padding-left: 6px;
      border-left: 2px solid #E63A18;
      line-height: 14px;
      margin: 15px 0 10px;
    }
    .box{
      padding: 20px;
      background: #FFFFFF;
      box-shadow: 0px 0px 15px 0px rgba(219, 219, 219, 0.4);
      border-radius: 6px;
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
      cursor: pointer;
      .left{
        width: 45px;
        height: 45px;
        img{
          width: 45px;
          height: 45px;
          border-radius: 50%;
          object-fit: cover;
        }
      }
      .right{
        width: calc(100% - 59px);
      }
      .name{
        color: #333;
        font-size: 16px;
        font-weight: 800;
        line-height: 20px;
      }
      .bottom{
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        margin-top: 10px;
        .price{
          color: #E13A34;
          font-size: 18px;
          font-weight: 800;
        }
        .time{
          height: 12px;
          img{
            width: 12px;
            height: 12px;
            vertical-align: top;
          }
          span{
            font-size: 12px;
            color: #8A8A8A;
            font-weight: 400;
            margin: 0 12px 0 6px;
            vertical-align: top;
            height: 12px;
            line-height: 12px;
            &:nth-last-child(1){
              margin-right: 0;
            }
          }
        }
        label{
          display: inline-block;
          width: 80px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          background: linear-gradient(45deg, #FB5D37 0%, #E13A34 99%);
          border-radius: 15px;
          font-size: 14px;
          color: #fff;
          font-weight: bold;
        }
      }
    }
  }
  .dialog{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 101;
    background: rgba(0, 0, 0, .5);
    .tips{
      position: fixed;
      z-index: 222;
      top: 50%;
      left: 50%;
      margin-left: -111px;
      width: 222px;
      text-align: center;
      padding: 20px 36px;
      box-sizing: border-box;
      color: #fff;
      font-weight: 400;
      font-size: 15px;
      background: rgba(0, 0, 0, .8);
      border-radius: 10px;
      margin-top: -30px;
    }
  }
}
</style>